import ScreenHeader from './ScreenHeader';

export default ScreenHeader;
